package com.klantenstop.web.data.models.domain

private const val RADIUS_KM5 = 5
private const val RADIUS_KM10 = 10
private const val RADIUS_KM25 = 25
private const val RADIUS_KM50 = 50
private const val DEFAULT_RADIUS_KM = 5

data class SearchParams(
    val query: String = "",
    val category: Category? = null,
    val radius: Radius = Radius.Km5,
    val locationSlug: String? = null
)

data class InitialSearchParams(
    val query: String = "",
    val coordinates: Coordinates? = null,
    val category: String? = null,
    val radius: Int = DEFAULT_RADIUS_KM
)

enum class Radius(val range: Int) {
    Km1(1),
    Km2(2),
    Km5(RADIUS_KM5),
    Km10(RADIUS_KM10),
    Km25(RADIUS_KM25),
    Km50(RADIUS_KM50)
}
